import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  businessProfileSetupApi,
  deleteApi,
  forgotPasswordApi,
  getUserDetailsApi,
  initiateImpersonateApi,
  leaveImpersonateApi,
  loginApi,
  logoutApi,
  profileSetupApi,
  registerUserApi,
  resendVerificationEmailApi,
} from "helpers/ApiManager";
import {
  BusinessProfileSetupArgs,
  ProfileArgs,
  RegisterArgs,
} from "types/auth.api";
import { ErrorHandler, SuccessToast } from "utils/toast";

export const registerUser = createAsyncThunk(
  "register/user",
  async (data: RegisterArgs, { rejectWithValue }) => {
    try {
      const response = await registerUserApi(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const loginUser = createAsyncThunk(
  "login/user",
  async (data: RegisterArgs, { rejectWithValue }) => {
    try {
      const response = await loginApi(data);
      console.log(response);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resendEmailVerification = createAsyncThunk(
  "resendEmailVerification",
  async (_, { rejectWithValue }) => {
    try {
      await resendVerificationEmailApi();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const profileSetup = createAsyncThunk(
  "profileSetup/user",
  async (data: ProfileArgs, { rejectWithValue }) => {
    try {
      const response = await profileSetupApi(data);
      SuccessToast(response.message);
      return response;
    } catch (error) {
      ErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);

export const logoutUser = createAsyncThunk(
  "logout/user",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as any;
      const userId = state?.auth?.user?.id;
      if (userId) {
        localStorage.removeItem(`stripe_connect_prompt_shown_${userId}`);
      }
      await logoutApi();
      dispatch({ type: "RESET_APP_STATE" });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "forgotPassword/user",
  async (email: string, { rejectWithValue }) => {
    try {
      const response = await forgotPasswordApi(email);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const businessProfileSetup = createAsyncThunk(
  "businessProfileSetup/user",
  async (data: BusinessProfileSetupArgs, { rejectWithValue }) => {
    console.log("Business Profile Setup Data:", data);

    try {
      const response = await businessProfileSetupApi(data);
      SuccessToast(response.message);
      return response;
    } catch (error) {
      ErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "delete/user",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as any;
      const userId = state?.auth?.user?.id;
      if (userId) {
        localStorage.removeItem(`stripe_connect_prompt_shown_${userId}`);
      }
      await deleteApi();
      dispatch({ type: "RESET_APP_STATE" });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUserDetails = createAsyncThunk(
  "user/userDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserDetailsApi();
      console.log("User Details Response:", response?.payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const initiateImpersonate = createAsyncThunk(
  "impersonate/initiate",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await initiateImpersonateApi(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const leaveImpersonate = createAsyncThunk(
  "impersonate/leave",
  async (_, { rejectWithValue }) => {
    try {
      const response = await leaveImpersonateApi();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
